import React, { useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { appendMetadataWithIndex } from 'ml-portals-util-react';

import MLPartnerCarrierChoicesComponent from './MLPartnerCarrierChoicesComponent';

import metadata from './MLPartnerCarrierLobsComponent.metadata.json5';
import styles from './MLPartnerCarrierLobsComponent.module.scss';

const MLPartnerCarrierLobsComponent = (props) => {
    const {
        option,
        optionIndex,
        pendingChoices,
        jobNumber,
        updatePendingChoices
    } = props;


    const lobOverrides= useCallback(() => {
        const optionOverrides = option.lobs.map((lob, index) => {
            return {
                [`lobDisplayKey${optionIndex}${index}`]: {
                    content: lob.displayKey
                },
                [`mlPartnerCarrierChoicesComponent${optionIndex}${index}`]: {
                    option,
                    optionLobIndex: `${optionIndex}${index}`,
                    pendingChoices,
                    jobNumber,
                    lob,
                    updatePendingChoices
                }
            };
        });
        return Object.assign({}, ...optionOverrides);
    }, [jobNumber, option, optionIndex, pendingChoices, updatePendingChoices]);


    const overrides = {
        [`lobIterable${optionIndex}`]: {
            data: option.lobs
        },
        ...lobOverrides()
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            mlPartnerCarrierChoicesComponent: MLPartnerCarrierChoicesComponent
        }
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, optionIndex);
    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
};

MLPartnerCarrierLobsComponent.propTypes = {
    optionIndex: PropTypes.number.isRequired,
    option: PropTypes.shape({}).isRequired,
    pendingChoices: PropTypes.shape({}).isRequired,
    jobNumber: PropTypes.string.isRequired,
    updatePendingChoices: PropTypes.func.isRequired
};

export default MLPartnerCarrierLobsComponent;
